import { createAction } from '@reduxjs/toolkit';

export const UPDATE_AGENT_STATUS_ACTION_TYPE = 'saga/updateAgentStatus';
export const updateAgentStatusAction = createAction(UPDATE_AGENT_STATUS_ACTION_TYPE);
